module.exports = __webpack_public_path__ + "img/question.49acab3b.svg";